import React, { useCallback, useState } from 'react';

import { Tabs } from 'antd';

import TopPage from 'v2/components/Shared/TopPage';

import Producer from './Producer';
import Product from './Product';

type ITabs = 'producer' | 'product';

const Rating = () => {
  const [tab, setTab] = useState<ITabs>('producer');

  const handleChange = useCallback((v: string) => setTab(v as ITabs), []);
  return (
    <>
      <TopPage title='Avaliações' extra='Acompanhe as avaliações dos seus produtos e como produtor.' disableAlerts />

      <Tabs
        activeKey={tab}
        onChange={handleChange}
        items={[
          { key: 'producer', label: 'Como Produtor' },
          { key: 'product', label: 'Produtos' }
        ]}
      />

      {tab === 'producer' && <Producer />}
      {tab === 'product' && <Product />}
    </>
  );
};

export default Rating;
